import React, { useState, useEffect, useCallback } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import api from "api";
import { useDispatch, useSelector } from "react-redux";
import { setHealthPlan } from "slices/hpSlice";
import { useSearchParams } from "react-router-dom";

const dropdownStyles = {
  PaperProps: {
    style: {
      maxHeight: 200,
      overflowY: "auto",
    },
  },
};

export default function HealthPlanSelect() {
  const [searchParams, setSearchParams] = useSearchParams();
  const hpSearch = searchParams.get("hp");
  const [healthPlans, setHealthPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const selectedPlan =
    useSelector((state) => state.healthPlan.healthPlan?.healthPlanKey) || "";
  const dispatch = useDispatch();

  useEffect(() => {
    if (hpSearch && healthPlans.length) {
      const hp = healthPlans.find(
        (hp) => hp.healthPlanName.toLowerCase() === hpSearch.toLowerCase()
      );

      dispatch(setHealthPlan(hp));
    }
  }, [dispatch, healthPlans, hpSearch]);

  useEffect(() => {
    // Replace with your actual endpoint
    const fetchHealthPlans = async () => {
      try {
        const response = await api.healthPlanList.listHealthPlans();

        if (response.status === 200 && response.data.length > 0) {
          setHealthPlans(response.data);
        } else if (response.data.length < 1) {
          console.error("API returned an empty list of health plans.");
        }
      } catch (error) {
        console.error("Could not fetch health plans", error);
      } finally {
        setLoading(false); // Set loading to false after data is fetched
      }
    };

    fetchHealthPlans();
  }, []);

  const updateSearchParam = useCallback(
    (hpName) => {
      const newParam = new URLSearchParams(searchParams);
      if (newParam.get("hp")) newParam.set("hp", hpName);
      else newParam.append("hp", hpName);
      return newParam;
    },
    [searchParams]
  );

  const handleChange = (event) => {
    const selectedPlanKey = event.target.value;
    const newSelectedPlan = healthPlans.find(
      (plan) => plan.healthPlanKey === parseInt(selectedPlanKey)
    );

    setSearchParams(updateSearchParam(newSelectedPlan.healthPlanName));
    dispatch(setHealthPlan(newSelectedPlan));
  };
  useEffect(() => {
    // to set the search param when the selected plan is changed
    if (!hpSearch && healthPlans.length && selectedPlan) {
      const newSelectedPlan = healthPlans.find(
        (plan) => plan.healthPlanKey === parseInt(selectedPlan)
      );
      setSearchParams(updateSearchParam(newSelectedPlan.healthPlanName));
    }
  }, [healthPlans, hpSearch, selectedPlan, setSearchParams, updateSearchParam]);
  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 1000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <FormControl fullWidth size="small" sx={{ marginTop: 1 }}>
        <InputLabel id="health-plan-select-label">Health Plan</InputLabel>
        <Select
          labelId="health-plan-select-label"
          id="health-plan-select"
          value={selectedPlan ? selectedPlan : ""}
          label="Health Plan"
          onChange={handleChange}
          MenuProps={dropdownStyles}
        >
          {healthPlans.map((plan) => (
            <MenuItem key={plan.healthPlanKey} value={plan.healthPlanKey}>
              {plan.healthPlanDisplayName} ({plan.healthPlanName})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
